var mp = mp || {};

// Slider - Hero
//-----------------------------------------------------------------
mp.sliderTeam = function () {
  var $slider = $(".team__nav_slider .slider");

  if (!$slider.length) {
    return;
  }

  $slick = $slider.slick({
    mobileFirst: true,
    autoplay: false,
    autoplaySpeed: 5000,
    fade: false,
    arrows: false,
    dots: false,
    speed: 1000,
    pauseOnFocus: false,
    pauseOnHover: false,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "20px",
    rows: 0,
    variableWidth: true,
    prevArrow: '<button type="button" class="slick-prev slick-arrow"></button>',
    nextArrow: '<button type="button" class="slick-next slick-arrow"></button>',
    responsive: [
      {
        breakpoint: 819,
        settings: "unslick",
      },
    ],
  });

  $(".team__nav_slider .slider").on(
    "beforeChange",
    function (event, slick, currentSlide, nextSlide) {
      $currentSlide = $("[data-slick-index=" + nextSlide + "]").children("a");
      $target = $currentSlide.data("toggle-hover");

      $("[data-toggle-hover], [data-toggle-content]").removeClass("active");
      $("[data-toggle-hover]").parent().removeClass("active");

      $currentSlide.addClass("active").parent().addClass("active");
      $('[data-toggle-content="' + $target + '"]').addClass("active");
    },
  );
};

// Slider - Articles
//-----------------------------------------------------------------
mp.sliderArticles = function () {
  var $slider = $(".articles__slider .slider");

  if (!$slider.length) {
    return;
  }

  $slick = $slider.slick({
    mobileFirst: true,
    autoplay: false,
    autoplaySpeed: 3000,
    fade: false,
    arrows: false,
    dots: false,
    speed: 800,
    pauseOnFocus: false,
    pauseOnHover: false,
    infinite: false,
    variableWidth: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: false,
    rows: 0,
    prevArrow: '<button type="button" class="slick-prev slick-arrow"></button>',
    nextArrow: '<button type="button" class="slick-next slick-arrow"></button>',
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 920,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 540,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
};

$(document).ready(function () {
  mp.sliderTeam();
});
